import {
  BlueprintParameterValue,
  BlueprintParameterValueType,
  BlueprintStepTemplate,
  BlueprintOperationType,
} from "../../../models/Blueprints";
import CreateOrUpdateForm from "./CreateOrUpdateForm";
import useBlueprintContext from "../context/useBlueprintContext";

interface Props {
  stepID: string;
  stepTemplate: BlueprintStepTemplate;
}

const BlueprintEditorRightPanelInitializeWrittenCommonModelForm = ({
  stepID,
  stepTemplate,
}: Props) => {
  const { blueprint } = useBlueprintContext();
  const validator = (valueKey: string, parameterValue: BlueprintParameterValue) => {
    if (parameterValue.is_unique_identifier || valueKey === "unique_identifier") {
      // Can't set null unique identifiers when initializing a model.
      return parameterValue.value_type !== BlueprintParameterValueType.none;
    }
    return true;
  };

  // If it's from initialize written common model step + bulk create bp, show bulk_writes_item_id
  const showBulkWritesItemId = blueprint.operation_type === BlueprintOperationType.BULK_CREATE;

  return (
    <CreateOrUpdateForm
      stepID={stepID}
      stepTemplate={stepTemplate}
      validator={validator}
      showBulkWritesItemId={showBulkWritesItemId}
    />
  );
};

export default BlueprintEditorRightPanelInitializeWrittenCommonModelForm;
